import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageLayout, Tabs, TabsContent, TabsList, TabsTrigger } from '@lognai/synapse-design-system-v2';
import { InsightsList, type InsightStatus } from '@lognai/plugin-ai-core-ui';

export const InsightsPage: React.FC = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState<InsightStatus>('active');

  return (
    <PageLayout className="animate-fade-in-up">
      <h1 className="text-2xl font-semibold mb-4">Insights</h1>
      <Tabs value={tab} onValueChange={(v) => setTab(v as InsightStatus)}>
        <TabsList>
          <TabsTrigger value="active">Active</TabsTrigger>
          <TabsTrigger value="resolved">Resolved</TabsTrigger>
          <TabsTrigger value="dismissed">Dismissed</TabsTrigger>
        </TabsList>
        <TabsContent value="active" className="pt-4">
          <InsightsList status="active" onNavigate={navigate} />
        </TabsContent>
        <TabsContent value="resolved" className="pt-4">
          <InsightsList status="resolved" onNavigate={navigate} />
        </TabsContent>
        <TabsContent value="dismissed" className="pt-4">
          <InsightsList status="dismissed" onNavigate={navigate} />
        </TabsContent>
      </Tabs>
    </PageLayout>
  );
};
